module.exports = __webpack_public_path__ + "b4984ec2f348d6834fcdb0499a289a29.pdf";